import { createProvider } from "./vue-apollo";
export default createProvider();
